export const patternEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/
export const patternPassword=/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
export const patternName = "[a-zA-ZÀ-ÖØ-öø-ÿ '-.]*";
export const patternLinkedin = /https:\/\/www\.linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?/


export const patternText= /^[a-zA-Z]+$/
export const patternTelephone = /^\d{8,20}$/;
export const patternfirstName = /^[A-Za-zÀ-ÖØ-öø-ÿ' -]+$/;
export const patternfirstNamechiffre = /^[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?à]*$/;



export const patternNamerole = "^(?!\\s)[a-zA-Z0-9_-]+$";
export const patternNumbersOnly = /^[0-9]+$/;

export const patternLinkedInURL = /^https:\/\/www\.linkedin\.com\/in\/[a-zA-Z0-9-]+/;

export const patternWebsiteURL = /^(?!.*linkedin\.com)(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,4})(\/\S*)?$/;
// export const patternWebsite = /^(https?:\/\/)?(www\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}|(?!www\.)[a-zA-Z0-9-]+\.[a-zA-Z]{2,}|www\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,})(\/\S*)?$/i;
export const linkedCompanyRegExp = /^https:\/\/(www\.)?linkedin\.com\/company\/[a-zA-Z0-9-]+\/?$/;

export const patternWebsite = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{1,3})$/i;

export const linkedInRegExp = /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+\/?$/;
export const patternWebsitefourniss = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[a-zA-Z0-9-._?&]*)*$/;
export const patternLinkedinfourniss = /https:\/\/www\.linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?/
export const patternInfoUser = /^[\s\S]{2,}$/;
export const urlRegExp = /^(https?:\/\/)?(www\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,}|(?!www\.)[a-zA-Z0-9-]+\.[a-zA-Z]{2,}|www\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,})(\/\S*)?$/i;